import React from 'react';
import QuickLink from '../../../../basic/quickLink';
import { ISubLinksFooterProps } from '../../IFooter';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../../../basic/analytics';

const PrivacyPolicy = ({ items }: ISubLinksFooterProps): JSX.Element => {
  const { label, url } = items || {};
  return (
    <QuickLink href={url} className="underline" dataAnalytics={buildAnalytics(DataAnalyticsLocations.Footer, DataAnalyticsTypes.Link)}>
      {label}
    </QuickLink>
  );
};

export default PrivacyPolicy;
